export const CUSTOMER_EXPERIENCE = {
  label: 'Customer Experience App',
  value: 'customer-experience',
  navigationLimit: 5,
  tabs: ['branding', 'integrations', 'modules', 'userContext', 'profile-viewer'],
  authOptions: [{ label: 'None', value: 'none' }],
}
